import { useEffect } from 'react'

// Redux.
import { connect } from 'react-redux';

// Firebase.
import { auth } from '../firebaseHelper';
import { useAuthState } from 'react-firebase-hooks/auth';

// Components.
import { useNavigate } from 'react-router-dom';
import NotesContent from '../components/NotesContent';

const Notes = ({
    authenticated,
}) => {

    const [user, userLoading, error] = useAuthState(auth);

    const safeAreaBottom = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--sab"));
    const navigate = useNavigate();

    useEffect(() => {
        const audio = document.getElementById('audio');
        audio.pause();
    }, [])

    return (
        <div className="container appScreen">
            <div className='main'>
                {userLoading ?
                    <div>
                        <div className='center'>
                            <div style={{ paddingBottom: `${safeAreaBottom + 20}px` }}>
                                <img className='glow icon' src='/icon.png' />
                            </div>
                        </div>
                    </div>
                    :
                    <NotesContent />
                }
            </div>
        </div >
    )
}

Notes.propTypes = {

}

Notes.defaultProps = {
}

const mapStateToProps = (state) => ({
    authenticated: state.user.authenticated,
})

const mapActionsToProps = {

}

export default connect(mapStateToProps, mapActionsToProps)(Notes);
